module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("购买人")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属部门")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("行政级别")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据名称"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("用途"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("采购事由")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("附件上传")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ede2758","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/attendance/buyOfficeApply.vue
// module id = xjH2
// module chunks = 1